import { Plugin } from 'prosemirror-state';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';

const TableDraggable = Table.extend({
  draggable: true,

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            dragstart(view, event) {
              const el = event.target as HTMLElement | null;
              const isHandle = el?.closest('.node-draggable-handle');
              const isInsideTable = el?.closest('table');

              if (!isHandle && isInsideTable) {
                event.preventDefault();
                event.stopPropagation();
                return true;
              }
              return false;
            },
          },
        },
      }),
    ];
  },
}).configure({
  resizable: true,
  HTMLAttributes: { class: 'tt-table' },
});

export const tableExtensions = [
  TableDraggable,
  TableRow,
  TableHeader.configure({ HTMLAttributes: { class: 'tt-th' } }),
  TableCell.configure({ HTMLAttributes: { class: 'tt-td' } }),
];
